import { GetSubmissionStepperQuery, SubmissionStepType } from "generated-graphql/graphql";
import { SubmissionStepState } from "hooks/useSubmissionSteps";
import { createContext } from "react";

type StepperSubmission = NonNullable<GetSubmissionStepperQuery["submission"]>;

export type WasteStepperContextValue = {
  submissionId: string;
  facilityId: string;
  /**
   * Null only while the shell is still loading. The shell renders skeletons (not
   * the `<Outlet/>`) until it resolves, so step routes/editors reading this via
   * `useWasteStepper()` always see a resolved submission.
   */
  submission: StepperSubmission | null;
  stepStates: Partial<Record<SubmissionStepType, SubmissionStepState>>;
  /**
   * True once the submission is frozen (`isSubmissionFrozen`): the snapshot has
   * been taken and the stepper is read-only. Step editors hide their
   * edit/continue affordances and the frozen snapshot view is rendered instead
   * of live tables.
   */
  isFrozen: boolean;
  /**
   * True when the current user may edit this submission's data. Staff-only
   * (`canEdit = isStaff && !isFrozen`): until RCRAInfo filing automation ships,
   * customers view the stepper read-only. A frozen submission is read-only for
   * everyone regardless.
   */
  canEdit: boolean;
};

/**
 * Raw context object. Consumers should read it via `useWasteStepper()` from
 * `hooks/useWasteStepper`; it is exported here only so that hook can subscribe to
 * it. Kept in this (component-free) module so `WasteStepperContext.tsx`'s only
 * export is the `WasteStepperProvider` component, satisfying
 * `react-refresh/only-export-components`.
 */
export const WasteStepperContext = createContext<WasteStepperContextValue | undefined>(undefined);
